import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const deleteBlackoutPeriod = async (domain: string, blackoutPeriodId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `blackout-period/${blackoutPeriodId}`,
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}